import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SurveyInterface } from 'app/assessment/survey/models';
import {
  LoadCurrentSurvey,
  LoadSurveys,
  ResetCurrentSurvey,
  UpdateCurrentSurvey,
  UpdateSurveyProgress } from 'app/assessment/survey/state/actions';
import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';
import { Observable } from 'rxjs/internal/Observable';

import { SurveyServiceInterface } from './survey-service.interface';

@Injectable()
export class SurveyService implements SurveyServiceInterface {

  constructor(private readonly _store: Store<AppStateInterface>) {}

  public getSurveyById(id: number): Observable<Readonly<SurveyInterface>> {
    return this._store.select(({ survey }: AppStateInterface) => survey.surveys[id]);
  }

  public getSelectedSurvey(): Observable<Readonly<number>> {

    return this._store.select(({ survey }: AppStateInterface) => survey.selectedSurvey);
  }

  public getSurveys(userId: number): Observable<Readonly<{ [id: number]: SurveyInterface }>> {
    this._store.dispatch(new LoadSurveys(userId));

    return this._store.select(({ survey }: AppStateInterface) => survey.surveys);
  }

  public updateSurvey(survey: SurveyInterface): Observable<SurveyInterface> {
    throw new Error('Method not implemented.');
  }

  public getSurveyProgress(): Observable<number> {
    return this._store.select(({ survey }: AppStateInterface) => survey && survey.surveyProgress);
  }

  public updateSurveyProgress(progress: number): Observable<number> {
    this._store.dispatch(new UpdateSurveyProgress(progress));

    return this._store.select(({ survey }: AppStateInterface) => survey.surveyProgress);
  }

  public getCurrentSurvey(userId?: number): Observable<Readonly<SurveyInterface>> {
    this._store.dispatch(new LoadCurrentSurvey(userId));

    return this._store.select(({ survey }: AppStateInterface) => survey.currentSurvey);
  }

  public updateCurrentSurvey(survey: SurveyInterface): Observable<SurveyInterface> {
    this._store.dispatch(new UpdateCurrentSurvey(survey));

    return this._store.select(({ survey }: AppStateInterface) => survey.currentSurvey);
  }

  public resetCurrentSurvey(survey: SurveyInterface): Observable<SurveyInterface> {
    this._store.dispatch(new ResetCurrentSurvey(survey));

    return this._store.select(({ survey }: AppStateInterface) => survey.currentSurvey);
  }

}
